export var CONTACT_MAIL_PLACEHOLDER = "__CONTACT__EMAIL__";
